import { prop } from '@ipfabric/utils/fp/prop';
import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';
import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectAllRoutes: (s: GlobalStateMergedState) => RoutesTreeItem[] =
  createScopedSelector(() =>
    createSelector(
      prop('createAllRoutes'),
      prop('oas'),
      (createAllRoutes, oas) => createAllRoutes(oas),
    ),
  );
